import { useEffect, useState } from 'react';
import api from './api';

// The admin-managed department and designation lists (GET /org-options),
// fetched once per page load and shared by every screen that needs them.
// Admin Settings calls refreshOrgOptions() after each change.

const EMPTY = { departments: [], designations: [], entries: { departments: [], designations: [] } };

let cache = null;
let pending = null;
const listeners = new Set();

const toState = (data) => ({
    departments: (data.departments || []).map(d => d.name),
    designations: (data.designations || []).map(d => d.name),
    // Full rows with _id, order and employee count, for Admin Settings.
    entries: { departments: data.departments || [], designations: data.designations || [] }
});

export const refreshOrgOptions = () => {
    pending = api.get('/org-options')
        .then(res => {
            cache = toState(res.data || {});
            listeners.forEach(fn => fn(cache));
            return cache;
        })
        .catch(err => {
            console.error('Could not load departments and designations', err);
            return cache || EMPTY;
        })
        .finally(() => { pending = null; });
    return pending;
};

export const useOrgOptions = () => {
    const [state, setState] = useState(cache || EMPTY);
    const [loading, setLoading] = useState(!cache);

    useEffect(() => {
        const onChange = (next) => { setState(next); setLoading(false); };
        listeners.add(onChange);
        if (!cache) (pending || refreshOrgOptions()).then(onChange);
        return () => listeners.delete(onChange);
    }, []);

    return { ...state, loading };
};
